import { render, staticRenderFns } from "./TransDoc.vue?vue&type=template&id=8dcb1d64&scoped=true&"
import script from "./TransDoc.vue?vue&type=script&lang=js&"
export * from "./TransDoc.vue?vue&type=script&lang=js&"
import style0 from "./TransDoc.vue?vue&type=style&index=0&id=8dcb1d64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcb1d64",
  null
  
)

export default component.exports